(function () {
  'use strict';
  var FinInfoTooltipController = function ($scope, labelSrvc) {
    $scope.msg = labelSrvc.getLabel;
  };
  FinInfoTooltipController.$inject = ['$scope', 'FinLabelSrvc'];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT + 'widgets/finModali/info-tooltip/finInfoTooltip.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var FinInfoTooltipComponent = {
    bindings: {
      dettaglioStrumento: '=?'
    },
    controller: FinInfoTooltipController,
    controllerAs: 'tooltipCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finInfoTooltip', FinInfoTooltipComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/finModali/info-tooltip/finInfoTooltip.js
 ** module id = 38
 ** module chunks = 1 2
 **/